import { h, Component } from "preact";

import ResultsSection from "./results-section";
import GoogleResults from "./google-results";

export default class ResultsList extends Component {
  render(props, state) {
    const {
      searchResults,
      searchRequest,
      term,
      type
    } = props;

    return (
      <div>
        {type == 'EWU' ? (
          <GoogleResults />
        ) : null}
      </div>
    );
  }
}
